const $button = $(".nav-trigger");

$button.on("click", function (e) {
	e.preventDefault();
	$("body").toggleClass("has-nav");
	$(".nav-trigger").toggleClass("nav-trigger--active");
	$(".tile__sub-links").removeClass("is-active");
	$(".tile").removeClass("is-hidden");
});
